import { useTranslation } from 'react-i18next';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import ScanCode from '@/components/scan-code/scan-code';

export default function ContactScanRoute() {
  const { t } = useTranslation();

  return (
    <PageLayout
      className='bg-gradient !pb-0'
      title={t('conversation.list.menu.scan-qr-code')}
      bannerColor='#000000'>
      <ScanCode />
    </PageLayout>
  );
}
